import dayjs from "dayjs";

export const unifyDate = (date: string | null | undefined) => {
  if (!date) return "";
  return dayjs(date).format("D MMM YYYY - HH:mm");
};
